import { createStore, applyMiddleware } from "redux"
import thunkMiddleware from "redux-thunk"
import { composeWithDevTools } from "redux-devtools-extension"
import state from "./state"

export default createStore(
  state,
  composeWithDevTools(applyMiddleware(thunkMiddleware)),
)
